module.exports = __webpack_public_path__ + "img/img_32389_0_154.8463fed0.png";